import {html} from 'lit';

export const facet10Template = () => html`
    <div class="image-shapes-10--crop-mobile">
        <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 360 270" xml:space="preserve">
            <path class="fill-violet500" d="M181.2,230.9c21.7,37.7,69.8,50.7,107.5,29c37.7-21.7,50.7-69.8,29-107.5L181.2,230.9z"/>
        </svg>
    </div>

    <div class="image-shapes-10">
        <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 380 380" xml:space="preserve">
            <path class="fill-violet500" d="M211.5,267.7c13.7,23.7,44,31.8,67.7,18.1c23.7-13.7,31.8-44,18.1-67.7L211.5,267.7z"/>
        </svg>
    </div>

    <div class="image-shapes-10-overlay">
        <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
             viewBox="0 0 380 380" xml:space="preserve">
            <polygon class="fill-blue" points="221.6,36.8 276.3,5.4 330.3,36.5 275.7,68 "/>
            <path class="fill-darkblue400-opacity-75" d="M250.3,82.5L275.7,68l-54.1-31.2l0,0l0.2,29.6C221.9,80.9,237.7,89.9,250.3,82.5z"/>
            <polygon class="fill-darkblue400" points="330.3,99.5 275.7,68 330.3,36.5 "/>
        </svg>
    </div>
`;